import { FormControl, Validators } from '@angular/forms';

const EMAIL_MAX_LENGTH = 254;

/** Bounded email format check without custom regex (uses Angular Validators.email). */
export function isValidEmailFormat(value: string): boolean {
  const email = value.trim();
  if (!email || email.length > EMAIL_MAX_LENGTH) {
    return false;
  }
  return new FormControl(email, Validators.email).valid;
}

/** Returns a user-facing error message, or null when valid / empty. */
export function validateEmailFormat(value: string): string | null {
  const email = value.trim();
  if (!email) {
    return null;
  }
  return isValidEmailFormat(email) ? null : 'Enter a valid email address.';
}
